











































import { BookComponents } from '../../components'
import { bookGoodsModelProvider } from '../model'
import { defineClassComponent, useFold } from '@/hooks'

export default defineClassComponent(
  {
    components: BookComponents,
  },
  () =>
    class {
      bookGoodsModel = bookGoodsModelProvider.inject()

      fold = useFold({
        container: 'container',
        trigger: 'trigger',
        height: 350,
      })
    },
)
